import React, { useState } from "react";
import { Button, Tab } from "semantic-ui-react";
import { BasicModal } from "../../../../components/Shared";
import {
  SupportList,
  SupportForm,
} from "../../../../components/SupportComponent";
import { useAuth } from "../../../../hooks";
import "./Page_Institution_Support.scss";

export function Page_Institution_Support() {
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onReload = () => setReload((prevState) => !prevState);
  const { accessToken, user } = useAuth();

  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          <SupportList
            reload={reload}
            onReload={onReload}
            user={user}
            accessToken={accessToken}
          />
        </Tab.Pane>
      ),
    },
  ];

  // Solo si NO eres partner, deberías poder "Crear Ticket"
  // (Asumiendo que esa es la lógica deseada.)
  const canCreateTicket = user?.role !== "partner";

  return (
    <>
      <div className="support-page">
        <div className="support-page__add">
          {canCreateTicket && (
            <Button primary onClick={onOpenCloseModal}>
              Nuevo Ticket
            </Button>
          )}
        </div>

        <Tab menu={{ secondary: true }} panes={panes} />
      </div>

      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title="Crear nuevo ticket de soporte"
        size="large"
      >
        <SupportForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          user={user}
          accessToken={accessToken}
        />
      </BasicModal>
    </>
  );
}
